import { signIn } from 'aws-amplify/auth'

import { API } from './api'
import { makeGetRequest, makePostRequest } from './fetchCalls'

async function postSignupUser({
  email,
  firstName,
  lastName,
  organization,
  password,
  plan,
  product,
  phone,
  specialty,
  recaptcha,
}) {
  return await makePostRequest(API.AUTH.SIGNUP, {
    body: JSON.stringify({
      email,
      first_name: firstName,
      last_name: lastName,
      organization,
      password,
      plan,
      product,
      phone,
      specialty,
      recaptcha,
    }),
  })
}

async function postLoginUser({ password, email }) {
  return await signIn({
    username: email,
    password: password,
  })
}

async function setVerifyUser({ code }) {
  return await makeGetRequest(API.AUTH.SET_VERIFY_USER(code))
}

async function getVerifyUser({ code }) {
  return await makeGetRequest(API.AUTH.VERIFY_USER(code))
}

async function getVerifyResetPasswordCode({ code }) {
  return await makeGetRequest(API.AUTH.VERIFY_RESET_PASSWORD(code))
}

async function postSetPassword({ email, password, code }) {
  return await makePostRequest(API.AUTH.SET_PASSWORD, {
    body: JSON.stringify({ email, password, code }),
  })
}

async function postResetPassword({ code, password }) {
  return await makePostRequest(API.AUTH.RESET_PASSWORD, {
    body: JSON.stringify({ password, code }),
  })
}

async function postForgotPassword({ email }) {
  return await makePostRequest(API.AUTH.FORGOT_PASSWORD, {
    body: JSON.stringify({ email }),
  })
}

async function postChangePassword({ password, newPassword }) {
  return await makePostRequest(API.AUTH.CHANGE_PASSWORD, {
    body: JSON.stringify({ password, new_password: newPassword }),
  })
}

async function postChangeEmail({ email, password }) {
  return await makePostRequest(API.AUTH.CHANGE_EMAIL, {
    body: JSON.stringify({ email, password }),
  })
}

async function getLoggedUser() {
  const response = await makeGetRequest(API.AUTH.USER_ME)
  return {
    ...response,
    picture: null,
  }
}

async function logoutUser() {
  return await makePostRequest(API.AUTH.LOGOUT)
}

async function socialLogin(code, provider) {
  return await makePostRequest(API.AUTH.LOGIN_SOCIAL, {
    body: JSON.stringify({ code, provider }),
  })
}

export async function resendVerificationEmail(email) {
  return await makePostRequest(API.AUTH.RESEND_VERIFICATION_EMAIL, {
    body: JSON.stringify({ email }),
  })
}

export async function syncUserInCognito(email: string, password: string) {
  return await makePostRequest(API.AUTH.COGNITO_SYNC, {
    body: JSON.stringify({ email, password }),
  })
}

export {
  getLoggedUser,
  getVerifyResetPasswordCode,
  getVerifyUser,
  logoutUser,
  postChangeEmail,
  postChangePassword,
  postForgotPassword,
  postLoginUser,
  postResetPassword,
  postSetPassword,
  postSignupUser,
  setVerifyUser,
  socialLogin,
}
